import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import SoftBox from "../SoftBox";

/**
 * Standard GMB frosted-glass modal paper — light, true-centered, compact.
 * Shared so every modal on the dashboard reads as one visual system instead
 * of each screen re-implementing its own "paper" styling (some of which,
 * like the old Feed Settings modal, were still on the legacy dark theme).
 */
export const glassModalPaperStyle = (maxWidth = { mini: "92%", xs: "92%", sm: "400px" }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  background: "rgba(255,255,255,0.72)",
  borderRadius: "8px",
  boxShadow: "0px 24px 48px -8px rgba(16,24,40,0.18), inset 0px 1px 0px 0px rgba(255,255,255,0.7)",
  border: "1px solid rgba(255,255,255,0.6)",
  padding: "1.25rem 1.375rem",
  maxWidth,
  width: "100%",
  maxHeight: "88vh",
  overflowY: "auto",
  outline: "none",
  backdropFilter: "blur(18px) saturate(160%)",
  WebkitBackdropFilter: "blur(18px) saturate(160%)",
});

export const GlassModalCloseButton = ({ onClick, ariaLabel = "Close" }) => (
  <SoftBox
    component="button"
    type="button"
    aria-label={ariaLabel}
    onClick={onClick}
    sx={{
      width: 28,
      height: 28,
      borderRadius: "50%",
      border: 0,
      cursor: "pointer",
      background: "#F2F4F7",
      color: "#667085",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      "& svg": { fontSize: "1rem !important" },
      "&:hover": { background: "#EAECF0" },
    }}
  >
    <CloseIcon />
  </SoftBox>
);

export const glassModalDividerStyle = { marginTop: "1rem", border: 0, borderTop: "1px solid rgba(15,23,42,0.08)" };
